import i18n from "../../../i18n";import { Trans } from "react-i18next";import { useMemo } from "react";
import { Funnel } from "lucide-react";
import { ui } from "../../../components/ui/page";
import { Popover, PopoverTrigger, PopoverContent } from "../../../components/ui/popover";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue } from
"../../../components/ui/select";
import { REGULARIZATION_APPROVAL_FLOWS } from "../constants/shiftFormState";

export function ShiftFilterBar({
  statusFilter,
  setStatusFilter,
  overtimeFilter,
  setOvertimeFilter,
  compOffFilter,
  setCompOffFilter,
  approvalFlowFilter,
  setApprovalFlowFilter,
  allCount,
  activeCount,
  inactiveCount
}) {
  const tabs = [
  { key: "All", label: "All", count: allCount },
  { key: "Active", label: "Active", count: activeCount },
  { key: "Inactive", label: "Inactive", count: inactiveCount }];


  const activeFilterCount = useMemo(() => {
    let count = 0;
    if (overtimeFilter !== "All") count += 1;
    if (compOffFilter !== "All") count += 1;
    if (approvalFlowFilter !== "All") count += 1;
    return count;
  }, [overtimeFilter, compOffFilter, approvalFlowFilter]);

  const resetFilters = () => {
    setOvertimeFilter("All");
    setCompOffFilter("All");
    setApprovalFlowFilter("All");
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
      {/* Segmented Status Tab Controls */}
      <div className="flex items-center gap-1 border-b border-[var(--color-text-border)]/70 sm:border-b-0">
        {tabs.map((tab) => {
          const isActive = statusFilter === tab.key;
          return (
            <button
              key={tab.key}
              type="button"
              onClick={() => setStatusFilter(tab.key)}
              className={`inline-flex items-center gap-1.5 px-3 py-2.5 text-sm font-semibold border-b-2 transition ${
              isActive ?
              "border-[var(--color-primary)] text-[var(--color-primary)]" :
              "border-transparent text-[var(--color-text-secondary)] hover:text-foreground"}`
              }>
              
              {tab.label}
              <span
                className={`inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full text-[11px] font-bold ${
                isActive ?
                "bg-[var(--status-submitted-bg)] text-[var(--status-submitted-fg)]" :
                "bg-[var(--color-workspace)] text-[var(--color-text-secondary)]"}`
                }>
                
                {tab.count}
              </span>
            </button>);

        })}
      </div>

      {/* Funnel filter button + popover panel, matching attendance/leave convention */}
      <div className="flex items-center gap-2">
        <Popover>
          <PopoverTrigger asChild>
            <button type="button" className={ui.filterBtn}>
              <Funnel className="h-4 w-4" />
              <span><Trans i18nKey="formActions.filter" /></span>
              {activeFilterCount > 0 ?
              <span className="ml-0.5 inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-[var(--color-primary)] px-1.5 text-[11px] font-bold text-white">
                  {activeFilterCount}
                </span> :
              null}
            </button>
          </PopoverTrigger>
          <PopoverContent align="end" className="w-72 flex flex-col gap-3">
            <div>
              <p className="text-[11px] font-bold text-[var(--color-text-secondary)] uppercase tracking-wider mb-1">
                <Trans i18nKey="dateTime.overtime" />
              </p>
              <Select value={overtimeFilter} onValueChange={setOvertimeFilter}>
                <SelectTrigger className="h-10 w-full rounded-xl">
                  <SelectValue placeholder={i18n.t("dateTime.allOvertime")} />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="All"><Trans i18nKey="dateTime.allOvertime" /></SelectItem>
                  <SelectItem value="true"><Trans i18nKey="dateTime.overtimeEnabled" /></SelectItem>
                  <SelectItem value="false"><Trans i18nKey="dateTime.overtimeDisabled" /></SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div>
              <p className="text-[11px] font-bold text-[var(--color-text-secondary)] uppercase tracking-wider mb-1">
                <Trans i18nKey="organizationShifts.compOff" />
              </p>
              <Select value={compOffFilter} onValueChange={setCompOffFilter}>
                <SelectTrigger className="h-10 w-full rounded-xl">
                  <SelectValue placeholder={i18n.t("organizationShifts.allCompOff")} />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="All"><Trans i18nKey="organizationShifts.allCompOff" /></SelectItem>
                  <SelectItem value="true"><Trans i18nKey="organizationShifts.compOffEnabled" /></SelectItem>
                  <SelectItem value="false"><Trans i18nKey="organizationShifts.compOffDisabled" /></SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div>
              <p className="text-[11px] font-bold text-[var(--color-text-secondary)] uppercase tracking-wider mb-1">
                <Trans i18nKey="organizationShifts.approvalFlow" />
              </p>
              <Select value={approvalFlowFilter} onValueChange={setApprovalFlowFilter}>
                <SelectTrigger className="h-10 w-full rounded-xl">
                  <SelectValue placeholder={i18n.t("organizationShifts.allApprovalFlows")} />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="All"><Trans i18nKey="organizationShifts.allApprovalFlows" /></SelectItem>
                  {REGULARIZATION_APPROVAL_FLOWS.map((flow) =>
                  <SelectItem key={flow} value={flow}>
                      {flow.replace(/_/g, " ")}
                    </SelectItem>
                  )}
                </SelectContent>
              </Select>
            </div>

            {activeFilterCount > 0 ?
            <button
              type="button"
              onClick={resetFilters}
              className="self-start text-xs font-semibold text-[var(--color-primary)] hover:underline">
                <Trans i18nKey="formActions.clearFilters2" />
              
            </button> :
            null}
          </PopoverContent>
        </Popover>
      </div>
    </div>);

}
